

import api from '../api'; // your Axios instance
import axios from 'axios';

export function login(email: string, password: string) {
    return api.post('/login', {
        email,
        password,
    });
}


export function forgotPassword(email: string) {
    return api.post('/forgot-password', { email });
  }

export function resetPassword(
    email: string,
    password: string,
    password_confirmation: string,
    token: string
  ) {
    return api.post('/reset-password', {
      email,
      password,
      password_confirmation,
      token
    });
  }

export function logout() {
    return api.post('/logout');
}

export function updateUser(id: number, name: string, email: string, password: string, password_confirmation: string) {
    return api.post('/update-profile', {
        id,
        name,
        email,
        password,
        password_confirmation,
      });
}
